import { compose } from '@doltech/utils/lib/compose';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

const Main = styled.div``;

export const DoTestExerciseGapFillWithHintQuestionBase = (props: RenderElementProps) => {
  const { children, attributes } = props;

  return (
    <Main className="do-test-exercise-gap-fill-w-hint-qyestuib" {...attributes}>
      {children}
    </Main>
  );
};

export const DoTestExerciseGapFillWithHintQuestion = compose(observer)(
  DoTestExerciseGapFillWithHintQuestionBase
);
